
function init_sidebar_head(){
    console.log("++ Initiating Sidebar Head...");
    var acc = document.getElementsByClassName("sidebar-head");
    var i;

    if(window.innerWidth >= 800){
        for (i = 0; i < acc.length; i++) {
            acc[i].classList.toggle("active");
            var content = acc[i].nextElementSibling;
                if (!content) { console.warn('[obx] sidebar-head missing content sibling'); continue; }
                if (content.style.maxHeight) {
                    content.style.maxHeight = null;
                } else {
                    content.style.maxHeight = content.scrollHeight + "px";
                }
        }
    }  

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function () {
            this.classList.toggle("active");
            var content = this.nextElementSibling;
            if (!content) { console.warn('[obx] sidebar-head click with no content sibling'); return; }
            if (content.style.maxHeight) {
                content.style.maxHeight = null;
            } else {
                content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    }
}

function move_explicit_sidebar_block(target_id){
    //console.log(`++ Moving Sidebar: ${ target_id }`);

    const template = document.getElementById(target_id);

    if (!template) return; // Safeguard if template doesn't exist

    const templateContent = template.content.cloneNode(true);
    const templateContent2 = template.content.cloneNode(true);

    const targetDiv = document.querySelector("#boost-sd-filter-tree-column .boost-sd__filter-tree-vertical-option-list"); 
    const mobileTargetDiv = document.querySelector("#boost-sd_filter-tree-mobile .boost-sd__filter-tree-vertical-option-list"); 

    if (!targetDiv) return; // Safeguard if target div doesn't exist
    if (!mobileTargetDiv) return;

    // Create a new div and add the template content to it
    const desktopDiv = document.createElement("div");
    const mobileDiv = document.createElement("div");

    desktopDiv.id = "sidebar-color-picker";
    desktopDiv.classList.add("sidebar-color-picker");
    mobileDiv.id = "sidebar-color-picker-mobile";
    mobileDiv.classList.add("sidebar-color-picker");

    desktopDiv.appendChild(templateContent);
    mobileDiv.appendChild(templateContent2);

    // Insert the newDiv as the first child of the target div
    if (targetDiv) {
        targetDiv.insertBefore(desktopDiv, targetDiv.firstChild);
    } else {
        console.warn('[obx] Desktop sidebar target not found');
    }

    if (mobileTargetDiv) {
        mobileTargetDiv.insertBefore(mobileDiv, mobileTargetDiv.firstChild);
    } else {
        console.warn('[obx] Mobile sidebar target not found');
    }

}

function move_sidebar_color_return(target_id){
    //console.log(`++ Moving Color Return: ${ target_id }`);

    const template = document.getElementById(target_id);

    const templateContent = template.content.cloneNode(true);
    const mobileTargetDiv = document.querySelector("#boost-sd_filter-tree-mobile .boost-sd__filter-tree-vertical-option-list"); 

    if (!template) return; // Safeguard if template doesn't exist
    if (!mobileTargetDiv) return;

    const mobileDiv = document.createElement("div");

    mobileDiv.id = "sidebar-color-return-mobile";
    mobileDiv.classList.add("sidebar-color-return");

    mobileDiv.appendChild(templateContent);

    if (mobileTargetDiv) {
        mobileTargetDiv.insertBefore(mobileDiv, mobileTargetDiv.firstChild);
    } else {
        console.warn('[obx] Mobile target not found');
    }
    
}

function appendQueryToSidebarLinks(queryString) {
    const sidebarLinks = document.querySelectorAll('#sidebar-color-picker a.swatch-link');
    sidebarLinks.forEach(link => {
        link.href += (link.href.includes('?') ? '&' : '?') + queryString;
    });
}

